"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.start.recording': 'Start Recording',
    'conversation.start.failed': 'Failed to start conversation',
};
